var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined",
    transform: "translate(-308.000000, -201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(100.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-bug_report",
    transform: "translate(204.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M20,8 L17.19,8 C16.74,7.22 16.12,6.55 15.37,6.04 L17,4.41 L15.59,3 L13.42,5.17 C12.96,5.06 12.49,5 12,5 C11.51,5 11.04,5.06 10.59,5.17 L8.41,3 L7,4.41 L8.62,6.04 C7.88,6.55 7.26,7.22 6.81,8 L4,8 L4,10 L6.09,10 C6.04,10.33 6,10.66 6,11 L6,12 L4,12 L4,14 L6,14 L6,15 C6,15.34 6.04,15.67 6.09,16 L4,16 L4,18 L6.81,18 C7.85,19.79 9.78,21 12,21 C14.22,21 16.15,19.79 17.19,18 L20,18 L20,16 L17.91,16 C17.96,15.67 18,15.34 18,15 L18,14 L20,14 L20,12 L18,12 L18,11 C18,10.66 17.96,10.33 17.91,10 L20,10 L20,8 Z M16,12 L16,15 C16,15.22 15.97,15.47 15.93,15.7 L15.83,16.35 L15.46,17 C14.74,18.24 13.42,19 12,19 C10.58,19 9.26,18.23 8.54,17 L8.17,16.36 L8.07,15.71 C8.03,15.48 8,15.23 8,15 L8,11 C8,10.77 8.03,10.52 8.07,10.3 L8.17,9.65 L8.54,9 C8.84,8.48 9.26,8.03 9.75,7.69 L10.32,7.3 L11.06,7.12 C11.37,7.04 11.69,7 12,7 C12.32,7 12.63,7.04 12.95,7.12 L13.63,7.28 L14.24,7.7 C14.74,8.04 15.15,8.48 15.45,9.01 L15.83,9.66 L15.93,10.31 C15.97,10.53 16,10.78 16,11 L16,12 Z M10,14 L14,14 L14,16 L10,16 L10,14 Z M10,10 L14,10 L14,12 L10,12 L10,10 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.98fc637d.svg";
export { ForwardRef as ReactComponent };